import { render, staticRenderFns } from "./TableMenu.vue?vue&type=template&id=53691bb8"
import script from "./TableMenu.vue?vue&type=script&lang=ts"
export * from "./TableMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports